import {Component, OnDestroy, OnInit} from '@angular/core';
import {OrdineEsolver} from '../../_models/OrdineEsolver';
import {OrganizzazioniService} from '../../_services/organizzazioni.service';
import {AuthenticationService} from '../../_services/authentication.service';
import {LocalService} from '../../_services/local.service';
import {EventiService} from '../../_services/eventi.service';
import {ModalController} from '@ionic/angular';
import {Ordine, OrdineCreate} from '../../_models/Ordine';
import {StatoEnum} from '../../_models/generated/stato-enum';
import {TipoRisorsa} from '../../_models/generated/tipo-risorsa';
import {FileZundComponent} from '../../ordini/file-zund/file-zund.component';
import {SaveMessage} from '../../_helpers/save-message';
import {constants} from '../../_helpers/constants';
import {Movimento} from "../../_models/Movimento";
import {MovimentiService} from "../../_services/movimenti.service";
import {LicenzeService} from "../../_services/licenze.service";
import {RisorseService} from '../../_services/risorse.service';
import {LavorazioniService} from '../../_services/lavorazioni.service';
import {Risorsa} from '../../_models/Risorsa';
import {Lavorazione} from '../../_models/Lavorazione';
import {Subscription} from 'rxjs';
import {codiceValido, codiciRisorseProduzione, richiedeSceltaPersonale} from '../../_helpers/scelta-personale';

@Component({
  selector: 'app-ordine-esolver-launch',
  templateUrl: './ordine-esolver-launch.component.html',
  styleUrls: ['./ordine-esolver-launch.component.scss'],
  standalone: false
})
export class OrdineEsolverLaunchComponent implements OnInit, OnDestroy {
  ordine: OrdineEsolver;
  newOrdine: OrdineCreate;
  loadFile = false;
  loading = false;
  ordineUse: Ordine;
  ordineInUse = false;
  today = new Date().getTime();
  constants = constants;
  protected readonly TipoRisorsa = TipoRisorsa;
  // Feature 152: con «Risorse/Lavorazioni personali» attive la pianificata non personale va sostituita.
  bloccoRisorsa = false;
  bloccoLavorazione = false;
  risorsaScelta: Risorsa;
  lavorazioneScelta: Lavorazione;
  private codiciRisorse: string[] = [];
  private codiciLavorazioni: string[] = [];
  private subscriptions = new Subscription();

  constructor(
    public authService: AuthenticationService,
    public licenseService: LicenzeService,
    private organizzazioniService: OrganizzazioniService,
    private localService: LocalService,
    private eventiService: EventiService,
    private movimentiService: MovimentiService,
    private risorseService: RisorseService,
    private lavorazioniService: LavorazioniService,
    private modalCtrl: ModalController,
    private saveMessage: SaveMessage) { }

  ngOnInit() {
    if (!this.ordine) {
      console.error('OrdineEsolverLaunchComponent: this.ordine is undefined');
      return;
    }
    this.newOrdine = {
      rifOrdine: this.ordine.rifOrdine ?? '',
      idDocumento: this.ordine.idDocumento,
      idRiga: this.ordine.idRiga,
      idRigaLavorazione: this.ordine.idRigaLavorazione,
      organizzazioneId: this.organizzazioniService.organizzazioneId,
      risorsaId: 0,
      lavorazioneId: 0,
      dataRegistrazione: this.ordine.dataRegistrazione,
      numRegistrazione: this.ordine.numRegistrazione,
      codiceArticolo: this.ordine.codiceArticolo,
      varianteArt: this.ordine.varianteArt ?? '',
      descArticolo: this.ordine.descArt ?? '',
      quantita: this.ordine.quantita ?? 0,
      lotto: 1,
      quantitaOrdinataUdM2: this.ordine.quantitaOrdinataUdM2 ?? 0,
      quantitaLavorata: 0,
      quantitaScartata: 0,
      quantitaNonConforme: 0,
      coeffCar: 1,
      tempoLav: this.ordine.tempo ?? '',
      omacState: '',
      stato: StatoEnum.LANCIATO,
      flgTerminato: false,
      statoElimina: 0,
      dataTermine: this.ordine.dataTermine ? new Date(this.ordine.dataTermine) : new Date(),
      codiceRisorsa: this.ordine.risorsa ?? '',
      codiceLavorazione: this.ordine.lavorazione ?? '',
      commessa: this.ordine.commessa ?? '',
      umTempo: this.ordine.umTempo,
      note: '',
      notaInterna: this.ordine.notaInterna ?? '',
      notaFase: this.ordine.notaFase ?? '',
      codMagPrincipale: this.ordine.codMagPrincipale ?? '',
      codAreaMagPrinc: this.ordine.codAreaMagPrinc ?? '',
      udM: this.ordine.udM ?? '',
      udM2: this.ordine.udM2 ?? '',
      numFase: this.ordine.numFase ?? 0,
      rifLottoProdotto: this.ordine.rifLottoAlfanum ?? '',
      rifOdP: this.ordine.rifOdP ?? '',
      idOrdVen: this.ordine.idOrdVen ?? 0,
      numRegOrdVen: this.ordine.numRegistrazOrdVen ?? 0,
      numDocOrdVen: this.ordine.numDocOriginaleOrdVen ?? '',
      rifOrdVen: this.ordine.rifOrdVen ?? '',
      codCliente: this.ordine.codCliente ?? 0,
      ragSocialeCliente: this.ordine.ragSocialeCliente ?? '',
      faseContoLavoro: this.ordine.faseContoLavoro ?? 0,
      codTerzista: this.ordine.codTerzista ?? 0,
      ragSocialeTerzista: this.ordine.ragSocialeTerzista ?? '',
      lottoCode: this.organizzazioniService.autoLottoCode
    };
    this.subscriptions.add(this.risorseService.myRisorse
      .subscribe((risorse: Risorsa[]) => this.aggiornaBloccoRisorsa(risorse)));
    this.subscriptions.add(this.lavorazioniService.myLavorazioni
      .subscribe((lavorazioni: Lavorazione[]) => this.aggiornaBloccoLavorazione(lavorazioni)));
    this.getOrdine();
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  // Ricalcolato a ogni emissione: la lista personale può arrivare dopo l'apertura della finestra.
  // Svuota il campo solo se contiene ancora la pianificata, senza toccare una scelta già fatta.
  aggiornaBloccoRisorsa(risorse: Risorsa[]) {
    this.codiciRisorse = codiciRisorseProduzione(risorse);
    this.bloccoRisorsa = richiedeSceltaPersonale(this.ordine.risorsa, this.codiciRisorse,
      this.organizzazioniService.risorsePersonal);
    if (this.bloccoRisorsa && this.newOrdine.codiceRisorsa === (this.ordine.risorsa ?? '')) {
      this.newOrdine.codiceRisorsa = '';
    }
  }

  aggiornaBloccoLavorazione(lavorazioni: Lavorazione[]) {
    this.codiciLavorazioni = (lavorazioni ?? []).map((lavorazione: Lavorazione) => lavorazione.codice);
    this.bloccoLavorazione = richiedeSceltaPersonale(this.ordine.lavorazione, this.codiciLavorazioni,
      this.organizzazioniService.lavorazioniPersonal);
    if (this.bloccoLavorazione && this.newOrdine.codiceLavorazione === (this.ordine.lavorazione ?? '')) {
      this.newOrdine.codiceLavorazione = '';
    }
  }

  get risorsaNonValida(): boolean {
    return this.bloccoRisorsa && !codiceValido(this.newOrdine.codiceRisorsa, this.codiciRisorse, true);
  }

  get lavorazioneNonValida(): boolean {
    return this.bloccoLavorazione && !codiceValido(this.newOrdine.codiceLavorazione, this.codiciLavorazioni, true);
  }

  get lancioBloccato(): boolean {
    return this.risorsaNonValida || this.lavorazioneNonValida;
  }

  getOrdine = () => {
    this.ordineInUse = false;
    this.ordineUse = null;
    this.localService.getOrdineAsync(this.organizzazioniService.organizzazioneId,
      this.ordine.idDocumento, this.ordine.idRiga, this.ordine.idRigaLavorazione)
      .then((_ordine: Ordine) => {
        if (!_ordine) {
          return;
        }
        this.ordineUse = _ordine;
        this.ordineInUse = true;
      })
      .catch((err) => {
        if (err?.status !== 404) {
          console.error('Errore nel controllo ordine esistente', err);
        }
      });
  };

  createOrdine(ordine: OrdineCreate) {
    this.loading = true;
    this.localService.createOrdine(ordine)
      .then((ordineLocal: Ordine) => {
        this.saveMessage.messageInfo('Ordine lanciato con successo.');
        this.eventiService.creaEvento(StatoEnum.LANCIATO, ordineLocal, new Date())
          .then(() => this.modalCtrl.dismiss(ordineLocal, 'confirm'));
      })
      .catch(() => this.saveMessage.messageError("Problemi durante il lancio dell'ordine."))
      .finally(() => this.loading = false);
  }

  updateOrdine() {
    this.ordineUse.rifOrdine = this.newOrdine.rifOrdine;
    this.ordineUse.dataRegistrazione = this.newOrdine.dataRegistrazione;
    this.ordineUse.numRegistrazione = this.newOrdine.numRegistrazione;
    this.ordineUse.codiceArticolo = this.newOrdine.codiceArticolo;
    this.ordineUse.descArticolo = this.newOrdine.descArticolo;
    this.ordineUse.quantita = this.newOrdine.quantita;
    this.ordineUse.quantitaLavorata = this.newOrdine.quantitaLavorata;
    this.ordineUse.quantitaScartata = this.newOrdine.quantitaScartata;
    this.ordineUse.quantitaNonConforme = this.newOrdine.quantitaNonConforme;
    this.ordineUse.quantitaOrdinataUdM2 = this.newOrdine.quantitaOrdinataUdM2;
    this.ordineUse.tempoLav = this.newOrdine.tempoLav;
    this.ordineUse.stato = StatoEnum.LANCIATO;
    this.ordineUse.flgTerminato = false;
    this.ordineUse.statoElimina = 0;
    this.ordineUse.dataTermine = this.newOrdine.dataTermine;
    this.ordineUse.commessa = this.newOrdine.commessa;
    this.ordineUse.umTempo = this.newOrdine.umTempo;
    this.ordineUse.note = this.newOrdine.note;
    this.ordineUse.notaInterna = this.newOrdine.notaInterna;
    this.ordineUse.notaFase = this.newOrdine.notaFase;
    this.ordineUse.udM = this.newOrdine.udM;
    this.ordineUse.udM2 = this.newOrdine.udM2;
    this.ordineUse.numFase = this.newOrdine.numFase;
    this.ordineUse.codMagPrincipale = this.newOrdine.codMagPrincipale;
    this.ordineUse.codAreaMagPrinc = this.newOrdine.codAreaMagPrinc;
    this.ordineUse.rifLottoProdotto = this.newOrdine.rifLottoProdotto;
    this.ordineUse.rifOdP = this.newOrdine.rifOdP;
    this.ordineUse.idOrdVen = this.newOrdine.idOrdVen;
    this.ordineUse.numRegOrdVen = this.newOrdine.numRegOrdVen;
    this.ordineUse.numDocOrdVen = this.newOrdine.numDocOrdVen;
    this.ordineUse.rifOrdVen = this.newOrdine.rifOrdVen;
    this.ordineUse.codCliente = this.newOrdine.codCliente;
    this.ordineUse.ragSocialeCliente = this.newOrdine.ragSocialeCliente;
    this.ordineUse.faseContoLavoro = this.newOrdine.faseContoLavoro;
    this.ordineUse.codTerzista = this.newOrdine.codTerzista;
    this.ordineUse.ragSocialeTerzista = this.newOrdine.ragSocialeTerzista;
    this.loading = true;
    this.localService.updateOrdine(this.payloadAggiornamento())
      .then((ordineLocal: Ordine) => {
        // UpdateOrdine accoda e risponde senza corpo: senza fallback l'evento falliva su null (analysis A2).
        const ordine = ordineLocal ?? this.applicaSceltaLocale();
        this.saveMessage.messageInfo('Ordine aggiornato con successo.');
        this.eventiService.creaEvento(StatoEnum.LANCIATO, ordine, new Date())
          .then(() => this.modalCtrl.dismiss(ordine, 'confirm'));
      })
      .catch(() => this.saveMessage.messageError("Problemi durante il lancio dell'ordine."))
      .finally(() => this.loading = false);
  }

  // Risorsa e lavorazione scelte viaggiano solo come chiavi: gli oggetti delle liste personali
  // hanno la chiave API mascherata e annidati riscriverebbero la riga della risorsa (analysis A3).
  private payloadAggiornamento(): Ordine {
    const payload: Ordine = {...this.ordineUse};
    if (this.cambiaRisorsa()) {
      payload.risorsaId = this.risorsaScelta.id;
      payload.risorsa = null;
    }
    if (this.cambiaLavorazione()) {
      payload.lavorazioneId = this.lavorazioneScelta.id;
      payload.lavorazione = null;
    }
    return payload;
  }

  // Dopo l'invio l'ordine locale mostra gli oggetti scelti.
  private applicaSceltaLocale(): Ordine {
    if (this.cambiaRisorsa()) {
      this.ordineUse.risorsaId = this.risorsaScelta.id;
      this.ordineUse.risorsa = this.risorsaScelta;
    }
    if (this.cambiaLavorazione()) {
      this.ordineUse.lavorazioneId = this.lavorazioneScelta.id;
      this.ordineUse.lavorazione = this.lavorazioneScelta;
    }
    return this.ordineUse;
  }

  private cambiaRisorsa = (): boolean => !!this.risorsaScelta
    && this.risorsaScelta.codice === this.newOrdine.codiceRisorsa
    && this.risorsaScelta.id !== this.ordineUse.risorsaId;

  private cambiaLavorazione = (): boolean => !!this.lavorazioneScelta
    && this.lavorazioneScelta.codice === this.newOrdine.codiceLavorazione
    && this.lavorazioneScelta.id !== this.ordineUse.lavorazioneId;

  createMovimento(ordine: OrdineCreate) {
    this.loading = true;
    const movimento: Movimento = {
      organizzazioneId: this.organizzazioniService.organizzazioneId,
      id: 0,
      dataUnixRegistrazione: Math.floor(new Date().getTime() / 1000),
      rifOdP: ordine.rifOdP,
      idRigaMateriale: 0,
      codArt: ordine.codiceArticolo,
      unitaMisura: ordine.udM,
      magUdM: ordine.udM,
      quantita: ordine.quantitaLavorata,
      coeffX1: 1,
      codLottoAlfa: ordine.rifLottoProdotto,
      codMagazzinoIn: '', // _riga.codMag,
      codMagAreaIn: '', // _riga.codAreaMag,
      codBox: '',
      contesto: 4,  // Invio a Terzista
      // Il movimento al terzista non è soggetto al blocco (spec 152): con il campo svuotato resta la pianificata.
      codLav: this.lavorazioneNonValida ? this.ordine.lavorazione : ordine.codiceLavorazione,
      tipoMovimento: 1,
      currentGiacenza: 0,
      currentGiacenzaUdM2: 0,
      udM2: ordine.udM2,
      rifDocumento: ordine.rifOrdine,
      dataDocumento: ordine.dataRegistrazione,
      idAnagrafica: ordine.codCliente,
      saldaRiga: false,
    };

    this.movimentiService.ddtTrasferimentoInternoAsync(this.organizzazioniService.organizzazioneId,
      constants.DDTMESL, [movimento])
      .then((_movimento: Movimento) => this.modalCtrl.dismiss(true, 'confirm'))
      .catch(() => this.saveMessage.messageError("Ci sono problemi con la creazione dei movimenti di carico."))
      .finally(() => this.loading = false);
  }

  cancel = () => this.modalCtrl.dismiss(false, 'cancel');

  async openModal(element: any, _risorsa: any) {
    const modal = await this.modalCtrl.create({
      component: FileZundComponent,
      backdropDismiss: false,
      componentProps: {ordine: element, risorsa: _risorsa,},
      cssClass: 'custom-modal'
    });
    await modal.present();
    const {data} = await modal.onWillDismiss();
    if (data) {
      this.loadFile = true;
    } else if (!data) {
      this.loadFile = false;
    }
  }
}
